


















































































































import Vue from 'vue';
import HubIcon from '@/components/HubComponents/HubIcon.vue';
import HubMenu from '@/components/HubComponents/HubMenu.vue';

export default Vue.extend({
  name: 'HubTimePicker' as string,

  components: {
    HubIcon,
    HubMenu,
  },

  props: {
    label: {
      type: String,
      default: null,
    },
    showSeconds: {
      type: Boolean,
      default: false,
    },
    twelveHourClock: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      formattedTime: '',
      hours: [
        { hour: '00', period: 'AM' },
        { hour: '01', period: 'AM' },
        { hour: '02', period: 'AM' },
        { hour: '03', period: 'AM' },
        { hour: '04', period: 'AM' },
        { hour: '05', period: 'AM' },
        { hour: '06', period: 'AM' },
        { hour: '07', period: 'AM' },
        { hour: '08', period: 'AM' },
        { hour: '09', period: 'AM' },
        { hour: '10', period: 'AM' },
        { hour: '11', period: 'AM' },
        { hour: '12', period: 'PM' },
        { hour: '01', period: 'PM' },
        { hour: '02', period: 'PM' },
        { hour: '03', period: 'PM' },
        { hour: '04', period: 'PM' },
        { hour: '05', period: 'PM' },
        { hour: '06', period: 'PM' },
        { hour: '07', period: 'PM' },
        { hour: '08', period: 'PM' },
        { hour: '09', period: 'PM' },
        { hour: '10', period: 'PM' },
        { hour: '11', period: 'PM' },
      ] as { hour: string; period?: string }[],
      indexHour: 0,
      minutes: '00',
      seconds: '00',
      selectedHour: '00',
    };
  },

  computed: {
    timepickerStyle(): string {
      return `${this.showSeconds && 'grid-template-columns: auto auto auto auto auto'}`;
    },
    updatedTime(): string {
      let time = `${this.selectedHour} : ${this.minutes}`;

      time += this.showSeconds ? ` : ${this.seconds}` : '';
      time += this.twelveHourClock ? ` ${this.hours[this.indexHour].period}` : '';

      return time;
    },
  },

  watch: {
    indexHour(): void {
      this.selectedHour = this.hours[this.indexHour].hour;
    },
    updatedTime(): void {
      this.emitTime();
    },
  },

  mounted() {
    if (this.value) this.startTime();
    if (!this.twelveHourClock) this.twentyFourHourClock();

    this.emitTime();
  },

  methods: {
    changeDayPeriod(): void {
      const hour = this.indexHour + 12;

      this.indexHour = hour > 23 ? hour - 24 : hour;
    },
    decrement(time: string): void {
      if (time === 'hours') {
        this.indexHour = this.indexHour === 0 ? 23 : this.indexHour - 1;
        return;
      }

      const minutesOrSeconds = parseInt(this.$data[time], 10);

      if (minutesOrSeconds === 0) {
        this.$data[time] = '59';
        this.decrement(time === 'minutes' ? 'hours' : 'minutes');
      } else if (minutesOrSeconds >= 11) {
        this.$data[time] = (minutesOrSeconds - 1).toString();
      } else {
        this.$data[time] = `0${minutesOrSeconds - 1}`;
      }
    },
    emitTime(): void {
      const time = `${this.indexHour}:${this.minutes}:${this.seconds}`;

      this.$emit('input', time);
    },
    increment(time: string): void {
      if (time === 'hours') {
        this.indexHour = this.indexHour === 23 ? 0 : this.indexHour + 1;
        return;
      }

      const minutesOrSeconds = parseInt(this.$data[time], 10);

      if (minutesOrSeconds === 59) {
        this.$data[time] = '00';
        this.increment(time === 'minutes' ? 'hours' : 'minutes');
      } else if (minutesOrSeconds >= 9) {
        this.$data[time] = (minutesOrSeconds + 1).toString();
      } else {
        this.$data[time] = `0${minutesOrSeconds + 1}`;
      }
    },
    onlyNumbers(event: InputEvent): void {
      const input = event.target as HTMLInputElement;

      if (/\D+/.test(input.value)) {
        input.value = input.value.replace(/\D+/, '');
      }
    },
    startTime(): void {
      const time = this.value.split(':');
      const data = ['indexHour', 'minutes'];

      if (this.showSeconds) data.push('seconds');

      time[0] = parseInt(time[0], 10) > 23 ? '0' : time[0];

      time.forEach((value, index) => {
        this.$data[data[index]] = index === 0 ? parseInt(value, 10) : value.trim();
      });
    },
    twentyFourHourClock(): void {
      const hours: { hour: string }[] = [];

      this.hours.map((element, index) => {
        if (index >= 13) {
          return hours.push({ hour: `${parseInt(element.hour, 10) + 12}` });
        }
        return hours.push({ hour: element.hour });
      });
      this.hours = hours;
    },
    validate(event: InputEvent, time: string, maxValue?: number): void {
      const input = event.target as HTMLInputElement;
      const inputValue = parseInt(input.value, 10);

      if (time === 'hours' && maxValue) {
        const { period } = this.hours[this.indexHour];

        if (period === 'AM') {
          if (!inputValue || inputValue > (maxValue - 1)) {
            input.value = '00';
          }
        } else if (!inputValue || inputValue > maxValue) {
          input.value = '00';
        }

        if (inputValue >= 0 && inputValue <= 9) {
          input.value = `0${inputValue}`;
        }

        this.selectedHour = input.value;

        const hour = parseInt(this.selectedHour, 10);

        this.indexHour = this.hours.findIndex((element) => (
          parseInt(element.hour, 10) === hour && element.period === period
        ));

        return;
      }

      if (!inputValue || inputValue > 59) {
        input.value = '00';
      } else if (inputValue >= 0 && inputValue <= 9) {
        input.value = `0${inputValue}`;
      }

      this.$data[time] = input.value;
    },
  },
});
